import { CookieService } from "ngx-cookie";
import { WorkflowService } from "./api/workflow.service";
import { LocalAuthService } from "./auth/local-auth.service";
import { NavigationService } from "./utility/navigation.service";

export function initializeApplication(cookies: CookieService, localAuth: LocalAuthService, navigation: NavigationService): () => Promise<void> {
    return (): Promise<void> => {
        return new Promise((resolve, reject) => {
            try {
                //Place any app initialization code here.

                const authTokenJson = cookies.get("MC3-REFRESH");

                if (authTokenJson) {
                    let tokenObjects;
                    try {
                        tokenObjects = JSON.parse(authTokenJson);
                    }
                    catch (e) {
                        console.error(e);
                        console.log("Invalid JSON in mc3 cookie, ignoring");
                    }


                    //we want to use the most recent auth token between local storage and the cookie so we have the most recent roles and a non-expired token if available
                    //to prevent refreshing unnecessarily on new page loads
                    const localAuthTokenString = localAuth.getAuthToken()

                    if (localAuthTokenString) {
                        console.log("has local auth token)")
                        const localAuthToken = localAuth.parseAuthToken(localAuthTokenString)


                        if (!localAuthTokenString || localAuth.isAuthTokenExpired()) {
                            if (tokenObjects.accessToken) {
                                localAuth.setToken({ accessToken: tokenObjects.accessToken });
                                console.log("set token from cookie")
                            }

                        }
                        else if (localAuthTokenString && tokenObjects.accessToken) {

                            const cookieToken = localAuth.parseAuthToken(tokenObjects.accessToken)

                            if (cookieToken.exp > localAuthToken.exp) {
                                localAuth.setToken({ accessToken: tokenObjects.accessToken })
                                console.log("set token from cookie 2")
                            }
                        }

                    }
                    else {
                        if (tokenObjects.accessToken) {
                            localAuth.setToken({ accessToken: tokenObjects.accessToken })
                            console.log("set token from cookie 3")
                        }
                    }

                    if (!localAuth.loggedIn) {
                        //only set refresh token if we're not logged in.  They can only be used once, and we don't want to grab an old one on a page refresh

                        if (tokenObjects.refreshToken) {
                            localAuth.setRefreshToken(tokenObjects.refreshToken);
                        }

                    }







                }


                resolve();


            }
            catch (e) {
                reject(e);
            }


        });
    }
}